<script>
import TwBreadcrumbs from './TwBreadcrumbs';

export default {
  components: {
    TwBreadcrumbs,
  },
  props: {
    title: {
      type: String,
      required: true,
    },
    breadcrumbs: {
      type: Array,
      required: false,
      default: null,
    },
  },
};
</script>

<template>
  <div class="tw-title-bar">
    <v-list class="px-0 py-0">
      <v-list-tile>
        <v-list-tile-title class="title pb-0">
          {{ title }}
        </v-list-tile-title>
      </v-list-tile>
      <v-list-tile
        v-if="breadcrumbs">
        <tw-breadcrumbs
          :items="breadcrumbs"/>
      </v-list-tile>
    </v-list>
    <v-divider/>
  </div>
</template>



// WEBPACK FOOTER //
// src/components/TwTitleBar.vue